import 'slick-carousel'; 

jQuery( document ).ready(function($) {
    if($('body').hasClass('category-in_the_news')){
        $('.news-filters .categories a').removeClass('current');
        $('.news-filters .categories a:nth-child(3)').addClass('current');

        $('.news-filters form #catfilter').val('in_the_news')
    }
    if($('body').hasClass('category-press_release')){
        $('.news-filters .categories a').removeClass('current');
        $('.news-filters .categories a:nth-child(2)').addClass('current');

        $('.news-filters form #catfilter').val('press_release')
    }

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu').toggleClass('open');
    })
    $('.news-carousel').slick({ 
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '120px',
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 500,
                settings:{
                    slidesToShow: 1,
                    centerPadding: '30px',
                    initialSlide: 0,
                }
            },
            {
                breakpoint: 1000,
                settings:{
                    slidesToShow: 2,
                    initialSlide: 2,
                    centerPadding: '30px',
                }
            }
        ]
    });            
});